import { ROUTES, RouteInfo } from '../types/navigationTypes';

const BASE_PATH = '/applicationManagement';

export const buildPath = (segments: string[] = []): string => {
	return segments.length > 0 ? `${BASE_PATH}/${segments.join('/')}` : BASE_PATH;
};

export const buildRelativePath = (segments: string[] = []): string => {
	return segments.length > 0 ? segments.join('/') : '.';
};

export const buildHash = (segments: string[] = []): string => {
	return `#${buildPath(segments)}`;
};

export const parsePathToRoute = (fullPath: string): RouteInfo => {
	const path = fullPath.startsWith('#') ? fullPath.substring(1) : fullPath;
	const segments = path.split('/').filter(Boolean);

	if (segments.length === 0 || segments[0] !== 'applicationManagement') {
		return { route: ROUTES.APPLICATIONS };
	}

	const [, appId, opId, action] = segments;

	if (segments.length === 2 && appId === 'add') {
		return { route: ROUTES.ADD_APPLICATION };
	}

	if (segments.length === 3 && opId === 'edit') {
		return { route: ROUTES.EDIT_APPLICATION, applicationId: appId };
	}

	if (segments.length === 2) {
		return { route: ROUTES.APPLICATION_DETAILS, applicationId: appId };
	}

	if (segments.length === 3 && opId === 'add') {
		return { route: ROUTES.ADD_OPERATION, applicationId: appId };
	}

	if (segments.length === 4 && action === 'edit') {
		return {
			route: ROUTES.EDIT_OPERATION,
			applicationId: appId,
			operationId: opId,
		};
	}

	if (segments.length === 3) {
		return {
			route: ROUTES.OPERATION_DETAILS,
			applicationId: appId,
			operationId: opId,
		};
	}

	if (segments.length === 4 && action === 'export') {
		return {
			route: ROUTES.EXPORT_OPERATION_TO_TASK,
			applicationId: appId,
			operationId: opId,
		};
	}

	return { route: ROUTES.APPLICATIONS };
};

export const parseHashToRoute = parsePathToRoute;
